<template>
  <div class="inventory--alternative-tab" v-if="invoiceLineId || purchaseOrderLineId">
    <b-row class="alternative-grid-header">
      <b-col cols="12">
        <div class="pull-left tools">
          <div class="buttons-panel">
            <b-button @click="onEdit({})" size="sm" variant="primary" class="mr-2">
              <i class="fa fa-edit" aria-hidden="true"></i>
              Add Report
            </b-button>
            <b-button v-if="selectedRowItemId" @click="$refs['view-car-report-modal'].showModal()" size="sm" variant="primary" class="mr-2">
              <i class="fa fa-print" aria-hidden="true"></i>
              Print Report
            </b-button>
            <b-button v-if="selectedRowItemId" @click="sendEmail" size="sm" variant="primary">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              Email Report
            </b-button>
          </div>
            <b-container fluid>
              <b-modal
                id="car-scar-modal"
                ref="car-scar-modal"
                size="xl"
                @shown="getParentLineData"
                hide-footer
                header-close-label="Cancel"
                title="Corrective Action Report"
                scrollable
              >
                <AddReport :lineData="lineData" :reportDetails="reportDetails" :invoiceLineId="invoiceLineId" :otherData="otherData"
                           :purchaseOrderLineId="purchaseOrderLineId" @openEmailModal="sendEmail"
                           @refreshGrid="getCorrectiveActionReportList" @openReportModal="$refs['view-car-report-modal'].showModal()" />
              </b-modal>
            </b-container>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <grid-component
          isResizable
          isReorderable
          isSortable
          :gridId="gridId"
          :itemData="itemData"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortCorrectiveActionReportGrid"
          :onDelete="onDelete"
          :onEdit="onEdit"
          :handleRowClick="handleRowClick"
          :isTblLoader="tblLoader"
        />
        <!--        :totalItems="pageInfo.totalItems"-->
        <!--        :pageSizes="pageInfo.pageSize"-->
        <!--        :pageable="pageable"-->
        <!--        :skip="skip"-->
        <!--        :take="take"-->
        <!--        @getParentLineData="onGetData"-->
      </b-col>
    </b-row>
    <send-emails v-if="selectedRowItemId" :modalId="emailModalId" :sendEmailData="sendEmailData"></send-emails>
    <!-- <show-report-viewer :modalId="'view-car-report-modal'" v-if="selectedRowItemId" :parameter="{CAR: selectedRowItemId}" :reportName="'CAR-SCAR'"></show-report-viewer> -->
    <fast-report-viewer ref="view-car-report-modal" :modalId="'view-car-report-modal'" :parameter="selectedRowItemId" :moduleName="'CAR'" />
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapMutations } from 'vuex';
  import { GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
  import AddReport from './components/AddReport';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import fields from './fields';
  import SendEmails from '@/shared/components/SendEmails/index';
  import ShowReportViewer from '@/shared/components/ReportViewer';
  import FastReportViewer from '@/shared/components/FastReportViewer';

  export default {
    components: {
      AddReport,
      GridSettings,
      GridComponent,
      SendEmails,
      ShowReportViewer,
      FastReportViewer
    },
    props: {
      invoiceLineId: {
        type: [Number, String],
        default: 0,
      },
      purchaseOrderLineId: {
        type: [Number, String],
        default: 0,
      },
      otherData:{
        type: Object,
        default: () => {
        },
      }
    },
    data: () => ({
      lineData: {},
      reportDetails: {},
      fields,
      gridId: GRID_ID.CAR_SCAR_GRID,
      pageable: {
        pageSizes: 0,
      },
      selectedRowItemId: 0,
      sendEmailData:{},
      emailModalId: 'send-report-email-modal',
    }),
    computed: {
      ...mapGetters('carScarReports', [
        'pageInfo',
        'filters',
        'selectedItemId',
        'tblLoader',
      ]),
      ...mapGetters('carScarReports', {correctiveActionReportsList : 'gridList'}),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        if (this.correctiveActionReportsList == undefined || this.correctiveActionReportsList.length === 0) return [];
        return this.correctiveActionReportsList.map((car) => ({ ...car, selected: car.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapMutations('carScarReports', ['setItem']),
      ...mapActions('invoiceLines', ['getInvoiceLine']),
      ...mapActions('purchaseOrderLines', ['getPurchaseOrderLine']),
      ...mapActions('carScarReports', [
        'getCorrectiveActionReports',
        'sortCorrectiveActionReportGrid',
        'getCorrectiveActionReportPage',
        'deleteCar',
        'searchCorrectiveActionReport',
      ]),
      ...mapActions('account', ['saveGridSettings']),
      onEdit(props) {
        this.reportDetails = props;
        this.selectedRowItemId = props.id;
        this.$bvModal.show('car-scar-modal');
      },
      handleRowClick(row) {
        //this.setLastOpenedId(row.dataItem.id);
        this.selectedRowItemId = row.dataItem.id;
      },
      async onGetData(params) {
        await this.getCorrectiveActionReports(params);
      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({ });
        if (deleteConfirmed) {
          await this.deleteCar(row.id);
          await this.getCorrectiveActionReportList();
        }
      },

      async getParentLineData() {
        this.lineData = {};
          if (this.invoiceLineId) {
            this.lineData = await this.getInvoiceLine({
              'invoiceLineId': this.invoiceLineId,
            });
          } else if (this.purchaseOrderLineId) {
            this.lineData = await this.getPurchaseOrderLine(this.purchaseOrderLineId);
          }
      },
      getCorrectiveActionReportList(newRecord={}) {
        if (newRecord.id) {
          this.selectedRowItemId = newRecord.id;
          this.reportDetails = newRecord;
        } else {
          this.lineData = {};
          this.reportDetails = {};
        }
        this.getCorrectiveActionReports({});
      },
      openReportModal(reportData) {
        this.$emit('openReportModal',reportData);
      },
      sendEmail() {
        if(this.selectedRowItemId){
          this.sendEmailData = {
            source:'CAR',
            ReferenceId:this.selectedRowItemId,
          },
            this.$bvModal.show(this.emailModalId)
        }
      },
    },
    watch: {
      invoiceLineId() {
        this.lineData = {};
        this.reportDetails = {};
        this.selectedRowItemId = 0;
        /*this.setFilters({ invoiceLineId: this.invoiceLineId, purchaseOrderLineId: null });*/
        this.setItem({ resource: 'filters', payload: { invoiceLineId: this.invoiceLineId, purchaseOrderLineId: null } });
        this.getCorrectiveActionReportList();
      },
      purchaseOrderLineId() {
        this.lineData = {};
        this.reportDetails = {};
        this.selectedRowItemId = 0;
        /*this.setFilters({ invoiceLineId: null, purchaseOrderLineId: this.purchaseOrderLineId });*/
        this.setItem({ resource: 'filters', payload: { invoiceLineId: null, purchaseOrderLineId: this.purchaseOrderLineId } });
        this.getCorrectiveActionReportList();
      },
      correctiveActionReportsList() {
        //This function sets the first row as the selected row
        if(this.correctiveActionReportsList && this.correctiveActionReportsList.length > 0 && this.selectedRowItemId === 0){
          this.selectedRowItemId = this.correctiveActionReportsList[0].id;
        } else if(!this.correctiveActionReportsList.length){
          this.selectedRowItemId = 0;
        }
      },
    },
    mounted() {
      /*this.setFilters({
        invoiceLineId: (this.invoiceLineId) ? this.invoiceLineId : null,
        purchaseOrderLineId: (this.purchaseOrderLineId) ? this.purchaseOrderLineId : null,
      });*/

      this.setItem({ resource: 'filters',
        payload: {
          invoiceLineId: (this.invoiceLineId) ? this.invoiceLineId : null,
          purchaseOrderLineId: (this.purchaseOrderLineId) ? this.purchaseOrderLineId : null,
        }
      });

      (this.invoiceLineId || this.purchaseOrderLineId)?this.getCorrectiveActionReportList():'';
    },
  };
</script>
